import styled, { css } from 'styled-components'

import {
    AbsolutePositioning,
    FlexCentered,
    FullWidthHeight,
} from 'components/common/genericStyles'

export const Container = styled.div`
    width: 28px;
    height: 28px;
    position: relative;
    cursor: pointer;

    & > img {
        ${AbsolutePositioning}
    }
`
export const tooltipStyles = css`
    ${FullWidthHeight}
    ${FlexCentered}
    cursor: pointer;
`
